export default __webpack_public_path__ + "static/media/Y_Ybyra.5345a7bd.mp3";